import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  useGetRelatedProductsQuery,
} from '../../redux-modules/service';
import { ShowMoreLink } from '../../components/ui/view/ShowMoreLink';
import { Picture } from '../../components/ui/Picture';
import { SliderCards } from '../../components/ui/view/SliderCards';

function ProductDetailRelatedProducts({
  productId,
  loadingText,
}) {
  const {
    data,
    isFetching,
  } = useGetRelatedProductsQuery({ productId });
  const [limit, setLimit] = useState(8);

  if (isFetching || !data) {
    return (<div className="container">{loadingText}</div>);
  }

  const { total, translates } = data;
  const { product } = translates;
  let { relatedProducts } = data;

  relatedProducts = relatedProducts.slice(0, limit);

  return (
    <div className="section-main">
      <div className="container">
        <div className="section-main-head">
          <div className="row align-item-center">
            <div className="col-12 col-lg">
              <h2>{Craft.t(product, 'Related Products')}</h2>
            </div>
          </div>
        </div>

        <SliderCards className={`slider-cards sm slick-slider${total > limit ? ' mb-2a' : ''}`}>
          {relatedProducts.map((relatedProduct) => (
            <div key={`card${relatedProduct.id}`}>
              <a className="card-product" href={relatedProduct.url}>
                <div className="card-product-img">
                  <Picture image={relatedProduct.thumbnail} defaultTransform="xl-min" loading="lazy" />
                </div>
                <div className="card-product-body">
                  <h3>{relatedProduct.title}</h3>
                  {(relatedProduct.subtitle
                    || (relatedProduct.version && Craft.canViewReleaseNotes))
                    && (
                    <span className="exception">
                      {relatedProduct.subtitle ?? (Craft.canViewReleaseNotes && relatedProduct.version && (Craft.t(product, 'Version {version}', { version: relatedProduct.version })))}
                    </span>
                    )}
                </div>
              </a>
            </div>
          ))}
        </SliderCards>
        {limit < total && (
          <ShowMoreLink label={Craft.t(product, 'Show all related products')} onClick={() => setLimit(total)} />
        )}
      </div>
    </div>
  );
}

ProductDetailRelatedProducts.propTypes = {
  productId: PropTypes.string.isRequired,
  loadingText: PropTypes.string.isRequired,
};

export { ProductDetailRelatedProducts };
